import { Badge, Box, Button, Callout, Code, Container, DataList, Flex, Heading, IconButton, Spinner, Text } from "@radix-ui/themes"
import {ChatBubbleIcon, CopyIcon, InfoCircledIcon, LockOpen2Icon} from '@radix-ui/react-icons'
import React, { useEffect, useState } from "react"
import { Link, useNavigate, useParams } from "react-router"
import useFetch from "../../core/hooks/useFetch"
import UserService from "../../core/services/UserService"
import { IUser } from "../../core/types/services-types/user-types"
import Avatar from "../../components/common/renders/avatar-render"
import {ROUTES} from '../../routes/constants'
import { useAppSelector } from "../../core/store"
import { copyTextClipboard } from "../../utils"
import { toast, ToastContainer } from "react-toastify"
export default function Profile() {
    const {id} = useParams()
    const [user, setUser] = useState<IUser>()
    const navigate = useNavigate()
    const selfAccount = useAppSelector(state => state.user.user)
    const [fetchUser, isLoading, error, errors] = useFetch(async () => {
        if(id) {
        const data = await UserService.Get(id)
        setUser(data)
        }
    })
    const redirectToChat = () => {
        navigate(`${ROUTES.CHATS_ROUTE}?chat_id=${user?.id}`)
    }
    useEffect(() => {
        fetchUser()
    }, [])
    return (
        <Container className="p-10">
			<ToastContainer />
            {
            isLoading ?
            <Spinner />
                :
                user ? 
            <Container>
                <Flex align={'center'} justify={'between'} wrap={'wrap'}>
                <Flex align={'center'} className="heading-profile mb-5">
                <Avatar classes="shadow-lg" style={{width: '50px', height: '50px'}} name={user?.login || 'U'}/>
                <Flex direction={'column'}> 
                <Heading>
                    {user?.login}
                </Heading>
                <Text>
                    {user?.role === 'user' ? "Пользователь" : "Админ"}
                </Text>
                </Flex>
                </Flex>
                <Flex gap={'3'} className="buttons-actions">
                    <Button onClick={() => redirectToChat()}>
                        <ChatBubbleIcon />
                        Начать чат
                    </Button>
                    <Link to={ROUTES.SEND_MONEYS_SITE_ROUTE + `?user_id=${id}`}> 
                    <Button variant='surface'>
                        <LockOpen2Icon />
                        Отправить деньги
                    </Button>
                    </Link>
                </Flex>
                </Flex>
                <Container> 
                <Text weight={'bold'}>
                   Данные пользователя
                </Text>
                </Container>
                <hr />
                {selfAccount.role === 'admin' ? 
                <div className="data-user mt-10">
    <DataList.Root>
    <DataList.Item>
		<DataList.Label minWidth="88px">ID</DataList.Label>
		<DataList.Value>
			<Flex align="center" gap="2">
				<Code variant="ghost">{user.id}</Code>
				<IconButton
					size="1"
					aria-label="Copy value"
					color="gray"
					variant="ghost"
				>
					<CopyIcon onClick={async () => await copyTextClipboard(user.id.toString(), () => toast.success("ID скопирован в буфер обмена!"), (e: Error) => toast.error(`Ошибка копирования! ${e}`))} />
				</IconButton>
			</Flex>
		</DataList.Value>
	</DataList.Item>
	<DataList.Item align="center">
		<DataList.Label minWidth="88px">KYC</DataList.Label>
		<DataList.Value>
			<Badge color={user?.kyc_verifyed ? "jade" : 'red'} variant="soft" radius="full">
				{user?.kyc_verifyed ? "Верифицирован" : "Не верифицирован"}
			</Badge>
		</DataList.Value>
	</DataList.Item>
    <DataList.Item>
		<DataList.Label minWidth="88px">Емейл</DataList.Label>
		<DataList.Value>
			<Link to={`mailto:${user.email}` || '#'}>{user.email}</Link>
		</DataList.Value>
	</DataList.Item>
      <DataList.Item>
		<DataList.Label minWidth="88px">Номер телефона</DataList.Label>
		<DataList.Value>
			 {user.phone_number}
		</DataList.Value>
	</DataList.Item>
      <DataList.Item>
		<DataList.Label minWidth="88px">Номер карты</DataList.Label>
		<DataList.Value>
			 {user.card_number}
		</DataList.Value>
	</DataList.Item>
	<DataList.Item>
		<DataList.Label minWidth="88px">Имя</DataList.Label>
		<DataList.Value>{user.first_name}</DataList.Value>
	</DataList.Item>
	<DataList.Item>
		<DataList.Label minWidth="88px">Фамилия</DataList.Label>
		<DataList.Value>
			 {user.second_name}
		</DataList.Value>
	</DataList.Item>
	<DataList.Item>
		<DataList.Label minWidth="88px">Отчество</DataList.Label>
		<DataList.Value>
			 {user.sur_name}
		</DataList.Value>
	</DataList.Item>
    <DataList.Item>
		<DataList.Label minWidth="88px">Статус</DataList.Label>
		<DataList.Value>
			 	<Badge color={user?.kyc_verifyed ? "jade" : 'red'} variant="soft" radius="full">
				{user?.kyc_verifyed ? "Подписал документы" : "Не подписал документы"}
			</Badge>
		</DataList.Value>
	</DataList.Item>
    <DataList.Item>
		<DataList.Label minWidth="88px">Документ, удостоверяющий личность</DataList.Label>
		<DataList.Value>
			 {user.document_person}
		</DataList.Value>
	</DataList.Item>
     <DataList.Item>
		<DataList.Label minWidth="88px">Серия/номер документа</DataList.Label>
		<DataList.Value>
			 {user.series_number_passport}
		</DataList.Value>
	</DataList.Item>
     <DataList.Item>
		<DataList.Label minWidth="88px">Дата выдачи документа</DataList.Label>
		<DataList.Value>
			 {user.date_issue_passport}
		</DataList.Value>
	</DataList.Item>
     <DataList.Item>
		<DataList.Label minWidth="88px">Кем выдан</DataList.Label>
		<DataList.Value>
			 {user.whom_issue_passport}
		</DataList.Value>
	</DataList.Item>
     <DataList.Item>
		<DataList.Label minWidth="88px">Прописка</DataList.Label>
		<DataList.Value>
			 {user.place_of_residence}
		</DataList.Value>
	</DataList.Item>
        <DataList.Item>
		<DataList.Label minWidth="88px">Баланс (Рассвет)</DataList.Label>
		<DataList.Value>
			 {user.cash_site}
		</DataList.Value>
	</DataList.Item>
     <DataList.Item>
		<DataList.Label minWidth="88px">Баланс (Рубли)</DataList.Label>
		<DataList.Value>
			 {user.cash_rub}
		</DataList.Value>
	</DataList.Item>
</DataList.Root>
                </div>
                :
                <div className="access-denied">
                        <Callout.Root color='red' className="mt-5">
                        <Callout.Icon>
                            <InfoCircledIcon />
                        </Callout.Icon>
                        <Callout.Text>
                            Доступ запрещен!
                        </Callout.Text>
                    </Callout.Root>
                </div>
}
            </Container>
            :
            <Container>Пользователь не найден!</Container>
            }
        </Container>
    )
}